
<mat-progress-bar id="loader" mode="indeterminate" class="app-progress" *ngIf="messageService.isBusy || applicationService.isBusy"></mat-progress-bar>

<div *ngIf="messageService.isBusy || applicationService.isBusy" style="position: fixed; bottom: 10px; left: 10px; padding: 10px; z-index: 10000;">
  <div style="padding: 8px 30px 8px 16px; width: 174px; background-color: #FE8205; box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6); border-radius: 4px; color: #fff">
    <img src="assets/img/green-spinner.gif" style="height: 22px; margin-right: 10px" />
    <div style="display: inline-block; position: absolute; color: rgba(255, 255, 255, 0.8); font-weight: bold; margin-top: 3px">WORKING ON IT...</div>
  </div>
</div>

<div *ngIf="!applicationService.loaded" style="text-align: center; margin: 100px 0">
  Welcome to One AVBOB Connect...
</div>

<div *ngIf="showIdle" class="animated fadeIn" style="position: fixed; z-index: 10000; background-color: rgba(0, 0, 0, 0.6); top: 0; left: 0; right: 0; bottom: 0">

  <div style="display: table; height: 100%; width: 100%;" id="flex">
    <div style="display: table-cell; height: 100%; vertical-align: middle">
      <div style="margin: 10px auto; font-weight: bold; margin-top: -100px; text-align: center; max-width: 400px; background-color: #fff; box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1); padding: 12px; padding-top: 26px; border-radius: 4px">
        <div *ngIf="applicationService.idleState == 2">
          <div>{{ applicationService.idleWarning }}</div>
          <button mat-raised-button color="primary" style="margin: 20px;" (click)="continue()">Continue</button>
        </div>
        <div *ngIf="applicationService.idleState == 3">
          <div>
            Your session has timed out!
          </div>
          <button mat-raised-button color="primary" style="margin: 20px;" onclick="window.location.reload(true);">Continue</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isOnline" style="position: fixed; z-index: 9999; top: 0; left: 0; right: 0; bottom: 0; background-color: #ffffff; background: repeating-linear-gradient( -60deg, #fcfcfc, #fcfcfc 2px, #ffffff 2px, #ffffff 10px );">
  <div style="text-align: center; font-size: 20px; z-index: 10000; position: fixed; top: 50%; left: 50%; -webkit-transform: translate(-50%, -50%); transform: translate(-50%, -50%); padding: 10px 20px; margin-top: -100px;">
    <img src="assets/img/logo.png" style="width: 180px; margin: 16px">
    <div style="font-weight: 600; color: var(--green)">AVBOB Mutual Assurance Society</div>
    <div style="font-size: 16px"><i class="fas fa-exclamation-triangle" style="color: var(--orange); margin-right: 4px"></i> Your are currently offline</div>
  </div>
</div>




<div class="animated fadeIn" *ngIf="applicationService.loaded">

  <div class="site-header">
    <div class="container b-logos" style="position: relative">
      <div style="position: absolute; background-color: var(--green); box-shadow: 0 0 10px 0 rgba(0,0,0,.3); height: 120px; z-index: 5">
        <img src="assets/img/logo.png" style="width: 140px; margin-top: 16px">
      </div>
    </div>
    <div class="s-logos">
      <img src="assets/img/logo.png" style="height: 150px; margin: 0 auto">
    </div>
    <div style="background-color: var(--lime); border-bottom: 4px solid var(--green); padding: 20px 8px; min-height: 67px;">

      <div class="container" style="color: #fff;">
        <div class="connect_headers" style="font-size: 14px;">
          <div class="row">
            <div class="col-md-8">
              <span *ngIf="platform == 1"><strong>ONE AVBOB</strong> Connect</span>
              <span *ngIf="platform == 2 && !isKiosk">
                <strong>CONNECT </strong> Self Service
              </span>
              <span *ngIf="platform == 2 && isKiosk">
                Self Service <strong>KIOSK</strong>
              </span>
              <span *ngIf="platform == 3"><strong>SINAWE</strong></span>
              <span *ngIf="platform == 4"><strong>myBROKER CONNECT</strong></span>
              <div *ngIf="platform != 2" style="font-size: 12px; color: #ececec">
                {{ applicationService.currentUser ? "Connected as " + applicationService.currentUser : "Let's Connect!" }}
              </div>
            </div>
            <div class="col-md-4 text-right" style="font-size: 20px; color: rgba(255, 255, 255, 0.5); font-weight: 600">
              <img src="assets/img/icons/calendar.png" style="height: 26px; opacity: 0.8; margin-top: -4px " /> {{ applicationService.today | date: 'dd MMM yyyy' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <nav class="navbar" id="loginPanel" *ngIf="platform != 2">
      <div class="container">
        <div style="margin-left: 160px; width: 100%">
          <div style="color: var(--green);">
            <i class="fas fa-home" style="margin-right: 6px"></i>
            <span>Welcome to <strong>ONE AVBOB Connect!</strong></span>
          </div>
        </div>
      </div>
    </nav>

  </div>

  <div class="main-content scrollbar-type-3 sb-colored">
    <div class="page-content">
      {{ applicationService.checkOtp }}
      <div [class.m36]="env">
        <mat-sidenav-container>
          <mat-sidenav #sidenav mode="over">
          </mat-sidenav>
          <mat-sidenav-content>
            <div *ngIf="!applicationService.shell">
              <router-outlet></router-outlet>
            </div>
            <connect-shell *ngIf="applicationService.shell">
              <div style="margin: 100px auto; text-align: center">Loading your Connect environment...</div>
            </connect-shell>
            <div *ngIf="showCallbackPanel" class="container mt-3 mb-3">
              <div style="width: 100%; background-color: #fff; border-radius: 4px; font-size: 14px; border: 2px dotted var(--lime); padding: 12px; text-align: center">
                <div *ngIf="showCallbackButton">
                  If you get stuck during the application process, click the button below and one of our agents will be in contact to help you complete your application
                  <br /><button mat-button color="accent" style="margin-top: 10px" (click)="doCallBack()">PLEASE CALL ME BACK</button>
                </div>
                <div *ngIf="!showCallbackButton">
                  Thank You! Your details have been sent and a call center agent will be in contact shortly...
                </div>
              </div>
            </div>
          </mat-sidenav-content>
        </mat-sidenav-container>
      </div>
    </div>

    <nav class="footer">

      <div *ngIf="platform == 2" style="font-size: 16px; padding: 28px 10px; text-align: center; margin-top: -3px; background-color: rgba(22, 66, 24, 0.1); border-top: 4px solid #E7ECE7; border-bottom: 4px solid var(--green); ">
        Please <strong><a href="https://www.avbob.co.za/company/privacy-policy" target="_blank">click here</a></strong> to read our
        privacy policy and other financial services related information
        <i class="fas fa-caret-right" style="color: var(--green); font-size: 18px; position: absolute; margin-left: 8px; margin-top: 2px"></i>
      </div>

      <div class="container" style="padding-bottom: 15px; padding-top: 15px" *ngIf="!isKiosk">
        <div class="row">
          <div class="col-md-8">
            <div *ngIf="platform == 1 || platform == 2">
              <div style="font-size: 13px"><strong>For assistance, please contact the AVBOB Customer Care Centre on</strong></div>
              <div style="font-size: 24px; font-weight: 600; color: var(--green)">0861 28 26 21</div>
              <div><strong>"We're here for you®"</strong></div>
            </div>
            <div *ngIf="platform == 3">
              <div style="font-size: 24px; font-weight: 600; color: var(--green)">DO YOU NEED HELP?</div>
              <div>If you experience any issues with the Sinawe Platform, kindly contact your District Manager for assistance</div>
              <div>Should you require additional assistance, please dial <strong style="color: var(--green)">0800030031</strong>, or send an email to <strong style="color: var(--green)">sinawesupport@avbob.co.za</strong></div>
            </div>
            <div *ngIf="platform == 4">
              <div style="font-size: 24px; font-weight: 600; color: var(--green)">DO YOU NEED HELP?</div>
              <div>If you experience any issues with the platform, kindly contact Head Office for assistance</div>
              <div>Should you require additional assistance, please dial <strong style="color: var(--green)">0800030031</strong>, or send an email to <strong style="color: var(--green)">brokerconnectsupport@avbob.co.za</strong></div>
            </div>
          </div>
          <div class="col-md-4 helpdesk" style="font-size: 16px; padding-top: 12px;">
            <div style="display: inline-block; text-align: left" *ngIf="platform != 2">
              <div style="font-weight: 600"><i class="fas fa-phone" style="color: var(--green); font-size: 18px; margin-right: 6px"></i> (012) 303 1299</div>
              <div><i class="fas fa-envelope" style="color: var(--green); font-size: 18px; margin-right: 6px"></i> icthelpdesk@avbob.co.za</div>
            </div>
            <div style="display: inline-block; text-align: left" *ngIf="platform == 2">
              <div><i class="fas fa-envelope" style="color: var(--green); font-size: 18px; margin-right: 6px"></i> info@avbob.co.za</div>
            </div>
          </div>
        </div>
        <div class="row top-employer" *ngIf="platform == 2">
          <img src="assets/img/top-employer.png" style="max-width: 500px; width: 100%; margin: 0 auto" />
        </div>
      </div>

      <div style="font-size: 12px; text-align: center; margin-bottom: 1px; background-color: var(--green); color: #fff; padding: 4px">© <strong>AVBOB</strong> {{ applicationService.year }} - <a href="http://www.avbob.co.za/General/PrivacyPolicy" target="_blank" style="color: #ddd; text-decoration: underline">Privacy Policy</a> | <a href="http://www.avbob.co.za/General/Disclaimer" target="_blank" style="color: #ddd; text-decoration: underline">Disclaimer</a> | <strong>AVBOB</strong> is an authorised Financial Services Provider FSP 20656. <strong>AVBOB</strong> is a level 2 B-BBEE contributor</div>
      <div style="text-align: center; background-color: var(--lime); color: #fff; padding: 12px;">
        <div>Unauthorised access to this system is prosecutable by law. By accessing this system, you agree that your actions may be monitored.</div>
        <div>You agree to immediately notify <strong>AVBOB</strong> of any unauthorised use or suspected unauthorised use of your account or any other breach of security <span style="color: var(--lime);">{{ applicationService.connectVersion }}</span></div>
      </div>

    </nav>
  </div>
</div>
<div *ngIf="platform == 2 && platformstatus == 'yes' && settingsLoaded">
  <!-- Iframe for PRODUCTION -->
  <!--<iframe #myIframe *ngIf="environment === 'PRODUCTION'" id="myIframe" src="https://campaigns.xpressinformation.co.za/AvbobAVA/" frameborder="0" class="avaIframe"></iframe>-->
  <iframe #myIframe *ngIf="environment === 'PRODUCTION'" id="myIframe" src="https://campaigns.xpressinformation.co.za/AvbobChatbot/" frameborder="0" class="avaIframe"></iframe>
  <!-- Iframe for NON-PRODUCTION -->
  <!--<iframe #myIframe *ngIf="environment !== 'PRODUCTION'" id="myIframe" src="https://campaigns.xpressinformation.co.za/AvbobAVAQA/" frameborder="0" class="avaIframe"></iframe>-->
  <iframe #myIframe *ngIf="environment !== 'PRODUCTION'" id="myIframe" src="https://campaigns.xpressinformation.co.za/AvbobChatbot_QA/" frameborder="0" class="avaIframe"></iframe>

  <style>
    #myIframe {
      position: fixed;
      bottom: 5px;
      right: 5px;
      width: 105px;
      max-width: 105vw;
      height: 105px;
      max-height: 105vh;
      border: none;
      border-radius: 50%;
      align-items: center;
      z-index: 1000;
      /*position: fixed;
      bottom: 0;
      right: 0;
      width: 150px;
      height: 150px;
      border: none;
      z-index: 1000;*/
    }
  </style>
</div>


